import script from "./tenant.vue?vue&type=script&lang=ts&setup=true"
export * from "./tenant.vue?vue&type=script&lang=ts&setup=true"

import "./tenant.scss?vue&type=style&index=0&id=338fe230&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-338fe230"]])

export default __exports__